import { clsx } from 'clsx';
import { useState } from 'react';
import Skeleton from 'react-loading-skeleton';

import { QuestionMarkIcon } from '@/components/icons/input';
import { Tooltip } from '@/components/shared/Tooltip/Tooltip.tsx';

import cn from './styles.module.sass';

interface ISalesItemProps {
    color: string;
    itemName: string;
    itemDescription?: string;
    points: number;
    hasTooltip?: boolean;
    isLoading?: boolean;
}

export const SalesItem = ({
    color,
    itemName,
    itemDescription,
    points,
    hasTooltip,
    isLoading,
}: ISalesItemProps) => {
    const [isTooltipShown, setIsTooltipShown] = useState(false);

    const handleToggleTooltip = () => {
        setIsTooltipShown(!isTooltipShown);
    };

    return (
        <div className={cn.container}>
            {isLoading ? (
                <Skeleton containerClassName={cn.skeleton} height={34} />
            ) : (
                <>
                    <div style={{ background: color }} className={cn.circle} />
                    <div className={cn.content}>
                        <div className={cn.contentLeft}>
                            <div className={cn.itemName}>
                                {itemName}{' '}
                                {hasTooltip && (
                                    <span className={cn.qMarkIcon} onClick={handleToggleTooltip}>
                                        {QuestionMarkIcon}
                                    </span>
                                )}
                                {hasTooltip && isTooltipShown && (
                                    <Tooltip
                                        className={cn.tooltip}
                                        text="Будем начислять по 100 Б за каждый активный номер ежемесячно (если друг оплатит тариф вовремя"
                                    />
                                )}
                            </div>
                            {itemDescription !== undefined && (
                                <div className={cn.itemDescription}>{itemDescription}</div>
                            )}
                        </div>
                        <div
                            style={{ color }}
                            className={clsx(
                                cn.contentRight,
                                itemDescription !== undefined && cn.flexStart
                            )}
                        >
                            {points} Б
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};
